<template>
    <div class="financial-management-default parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <h1>收支報表</h1>
         <div class="btn-group" :class="{chart: hash == '#%E8%B2%A1%E5%8B%99%E5%A0%B1%E8%A1%A8' || hash == ''}">
            <router-link  :to="{ name: 'financialAccountingBook'}">
                <div class="border-button accounting-book" >
                    記帳本
                </div>
            </router-link>
            <router-link :to="{ name: 'financialBill'}">
                <div class="default-button bill-list" >
                    帳單列表
                </div>
            </router-link>
            <table-search v-if="hash == '#%E6%94%B6%E6%94%AF%E5%88%97%E8%A1%A8'" @changeWord="setFilterWord" ></table-search>
            <div v-if="hash == '#%E6%94%B6%E6%94%AF%E5%88%97%E8%A1%A8'" class="filter" @click="openFilter()">
                <img src="../../../assets/img/icon/filter_white.svg" alt="">
            </div>
        </div>
        <income-and-expenditure-filter :isOpen="isFilter" @filterClose="closeFilter" @changeFilter="setFilterQuery"></income-and-expenditure-filter>
        <tabs :key="componentKey">
            <tab name="財務報表" :selected="selected.chart" >
                <financial-chart></financial-chart>
            </tab>
            <tab name="收支列表" :selected="selected.list" >
                <income-and-expenditure></income-and-expenditure>
            </tab>
        </tabs>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import financialChart from '@/components/landlord/financialManagement/financialChart.vue';
import incomeAndExpenditure from '@/components/landlord/financialManagement/incomeAndExpenditure.vue';
import incomeAndExpenditureFilter from '@/components/landlord/financialManagement/incomeAndExpenditureFilter.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { mapGetters } from 'vuex'

export default {
    name: 'TenantManagement',
    data () {
        return {
            hash: null,
            myHeight: (window.innerHeight) + 'px',
            listIsFixed: false,
            isFilter: false,
            selected: {
                chart: false,
                list: false,
            },
            componentKey: 0,
        }
    },
    created (){
        this.$store.dispatch('sendEventLog', 'FINANCIAL_REPORT')  
        this.selectTabByHash()
    },
    mounted () {
        this.$analytics.logEvent('收支報表', { screen_name: '收支報表'})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.hash = val.hash
                this.forceUpdate()
            },
            // immediate: true,
            deep: true
        }
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)


            if( hashTag == '#財務報表' ){
                this.$analytics.logEvent('財務報表', { screen_name: '財務報表'})
                this.selected.chart = true
            }else if( hashTag == '#收支列表' ){
                this.$analytics.logEvent('收支列表', { screen_name: '收支列表'})
                this.selected.list = true
            }else{
                this.$analytics.logEvent('財務報表', { screen_name: '財務報表'})
                this.selected.chart = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.chart = false
            this.selected.list = false
            
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        },
        openFilter: function () {
            this.isFilter = true
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
        },
        closeFilter: function (value) {
            this.isFilter = value
            this.$store.commit('modalStatus/set_filter_mode', false)
        },
        setFilterWord: function (value) {
            this.$store.dispatch('setIncomeFilterWord', value)
        },
        setFilterQuery: function (value) {
            console.log(value)
            this.$store.dispatch('setIncomeFilterQuery', value)
        },
    },
    computed: {
        ...mapGetters({
            isModalMode: 'GET_MODAL_MODE'
        })
    },
    components: {
        Tabs,
        Tab,
        financialChart,
        incomeAndExpenditure,
        incomeAndExpenditureFilter,
        TableSearch
    }
}
</script>
<style lang="scss">
    .financial-management-default{
        position: relative;
        margin-top: 82px;
        > h1{
            margin-top: 26px;
            margin-bottom: 40px;
            font-size: 28px;
        }
        >.btn-group{
            position: absolute;
            display: flex;
            align-items: center;
            top: 2px;
            right: 20px;
            .accounting-book,
            .bill-list{
                box-sizing: border-box;
                width: 120px;
                padding: 14px 0;
                margin-left: 16px;
                font-weight: 500;
            }
            .table-search{
                margin-left: 16px;
            }
            .filter{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 44px;
                height: 44px;
                cursor: pointer;
                background: #a8a5a4;
                border-radius: 4px;
                margin-left: 16px;
            }
        }
        .tabs{
            position: absolute;
            top: 2px;
            left: 150px;
            ul li.is-active :after{
                bottom: -4px;
            }
        }
        .develop{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 1154px;
            height: 799px;
            border-radius: 8px;
            background: #fff;
        }
    }
    .financial-management-default.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            margin-left: -39px;
            border-bottom: 1px solid #f0f0f0;
        }
        >h1{
            position: fixed;
            top: -5px;
            z-index: 8;
        }
        >.btn-group{
            position: fixed;
            top: 18px;
            right: unset;
            z-index: 8;
            margin-left: 575px;
        }
        >.btn-group.chart{
            position: fixed;
            top: 18px;
            right: unset;
            z-index: 8;
            margin-left: 883px;
        }
        .tabs{
            position: fixed;
            margin-left: 152px;
            top: 27px;
            left: unset;
            z-index: 8;
        }
        .tabs-details{
            position: relative;
            padding-top: 59px;
            border-radius: 0 0 10px 10px;
            .table-list{
                border-radius: 0 0 10px 10px;
                .mask{
                    position: fixed;
                    background: #f6f6f6;
                    width: 1190px;
                    height: 50px;
                    top: 81px;
                    margin-left: -15px;
                    z-index: 9;
                }
                .table-list-title{
                    position: fixed;
                    background: #fff;
                    top: 96px;
                    border-radius: 10px 10px 0 0 ;
                    z-index: 9;
                }
            
            }
            
        }
    }
    @media screen and (max-width: 1280px){
        .financial-management-default{
            .develop{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 1128px;
                height: 799px;
                border-radius: 8px;
                background: #fff;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/financialManagementPages/financialManagementDefault.vue